import React from 'react';

export default props => {
    return (
        <div className="menu">
            <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
                <a className="navbar-brand" href="/HOn/Home">HOn - Holerite On-line</a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav navbar-dark bg-primary" >
                        <li className="nav-item active">
                            <a className="nav-link" href="/HOn/Home">Home <span className="sr-only">(current)</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/HOn/ListaPedido">Lista de Pedidos</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/HOn/ListaAdiantamento">Lista de Adiantamentos</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/HOn/ListaFolha">Lista de Holerites</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/HOn/ListaArquivosRede">Informe de Rendimentos</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/HOn/TrocaSenha">Trocar Senha</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}